import React, { Component } from "react";
import { App } from "../../App";
import { AppScreen } from "../../AppScreen";
import landingFooterImage from "../../assets/images/landing-footer.png";
import landingSun from "../../assets/images/sun.png";

export interface CloseButtonProps
{
    onClicked: () => void;
}

interface CloseButtonState 
{
}

export class CloseButton extends Component<CloseButtonProps, CloseButtonState>
{
    constructor(props: CloseButtonProps)
    {
        super(props);

        this.state = {
        };
    }

    public render(): JSX.Element
    {
        return (
            <div className="menu-container">
                <div className="menu-btn-container">
                    <button className={"hamburger is-active"} onClick={this.props.onClicked.bind(this)} title="Close menu">
                        <div className="hamburger-box">
                            <div className="hamburger-inner"></div>
                        </div>
                    </button>
                </div>
            </div>
        );
    }
}